import $ from 'jquery';

$(document).ready(function () {

  if (typeof CKEDITOR !== 'undefined') {

    $('header').css({ height: 'auto' });
    $('.slider-btns').hide();
    $('.bg-wrap, .navbar').addClass('editable');
  }

  $('.quick-links').find('a[href^="#"]').click(function (e) {
    e.preventDefault();

    const $target = $($(this).attr('href'));
    if ($target) {
      const holderId = $target.closest('.ttab').attr('id');
      $(`.sorting a[data-target="#${holderId}"]`).click();
    }

    // return false;
  });

  $('.quick-links .toggle-button').click(function () {

    $(this).toggleClass('open');

    if ($(this).hasClass('open')) {
      $(this).html('<span>Přehled lokalit</span>');
      $(this).siblings('.quick-links-inner').addClass('closed');
    } else {
      $(this).html('<span>Skrýt</span>');
      $(this).siblings('.quick-links-inner').removeClass('closed');
    }

    return false;
  });

  $('.tabbed [data-target]').click(function (e) {
    e.preventDefault();

    $(this).closest('.sorting').find('a').removeClass('active');
    $(this).addClass('active');

    const target = $(this).data('target');

    $(target).siblings('.ttab').hide();
    $(target).show();

    window.history.replaceState('', '', updateURLParameter(window.location.href, 'tab', target.substr(1)));

    mapify($(target));

    return false;
  });

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const tab = params.tab;
  if (tab) {
    $('.tabbed [data-target="#' + tab + '"]').click();
  }

  // const activeTab = $('.sorting').find('a.active').data('target');
  setTimeout(() => {
    mapify($('.ttab'));
    // $('.peel-svg-clip-element').hide();
  }, 600);
});


function mapify($holder) {

  if (typeof CKEDITOR !== 'undefined') {
    return;
  }

  if ($holder.attr('data-processed') === 'true') {
    return;
  }

  $holder.find('.peel').each(function () {

    const coords = $(this).find('img').attr('alt');
    if (coords) {

      const width = parseInt($(this).width());
      const height = parseInt($(this).height());

      const [x, y] = parseCoords(coords);

      const id = $(this).find('.map-holder').attr('id');

      $(this).after(`<a href="https://mapy.cz/zakladni?x=${x}&y=${y}&z=18" target="_blank" class="map-link">Zobrazit na mapě</a>`)

      var center = SMap.Coords.fromWGS84(parseFloat(x), parseFloat(y));
      var m = new SMap(JAK.gel(id), center, 15);
      m.addDefaultLayer(SMap.DEF_BASE).enable();

      var sync = new SMap.Control.Sync();
      m.addControl(sync);

      var layer = new SMap.Layer.Marker();
      m.addLayer(layer);
      layer.enable();

      var options = {};
      var marker = new SMap.Marker(center, id + '_marker', options);
      layer.addMarker(marker);

      var imgTop = $(this).find('.peel-top img')[0],
        targetId = '#' + $(this).attr('id');

      if (imgTop.complete) {
        mapPeel(targetId, width, height);
      } else {
        imgTop.onload = function () {
          mapPeel(targetId, width, height);
        }
      }

    }
  });

  $holder.attr('data-processed', 'true');
}

function mapPeel(id, width, height)
{
  var p = new Peel(id, {
    corner: Peel.Corners.TOP_RIGHT
  });

  p.setMode('book');
  p.setPeelPosition(width / 1.25, height / 4);
  p.setPeelPath(width / 1.25, height / 4, -638, 452);
  p.t = 0;
  var tween = new TweenLite(p, 1.2, {
    t: 1,
    paused: true,
    ease: Power2.easeOut,
    onUpdate: function() {
      p.setTimeAlongPath(this.target.t);
    },
  });

  // automatic drag
  p.handlePress(function(evt) {
    if (p.t > .5) {
      tween.reverse();
    } else {
      tween.play();
    }
  });
}

/**
 * http://stackoverflow.com/a/10997390/11236
 */
function updateURLParameter(url, param, paramVal) {
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    tempArray = additionalURL.split("&");
    for (var i=0; i<tempArray.length; i++){
      if(tempArray[i].split('=')[0] != param){
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }

  var rows_txt = temp + "" + param + "=" + paramVal;
  return baseURL + "?" + newAdditionalURL + rows_txt;
}
